import {
	Action,
	AnyAction,
	ThunkAction,
	combineReducers,
	configureStore,
} from '@reduxjs/toolkit';

import adsSlice from './slices/adsSlice';
import bankSlice from './slices/bankSlice';
import contactsSlice from './slices/contactsSlice';
import messengerSlice from './slices/messengerSlice';
import phoneSlice from './slices/phoneSlice';
import settingsSlice from './slices/settingsSlice';

const reducers = {
	phone: phoneSlice,
	messenger: messengerSlice,
	settings: settingsSlice,
	bank: bankSlice,
	contacts: contactsSlice,
	ads: adsSlice,
};

const rootReducer = combineReducers(reducers);

const combinedRootReducer = (
	state: ReturnType<typeof rootReducer> | undefined,
	action: AnyAction,
) => {
	if (action.type === 'resetStore') {
		return rootReducer(undefined, action);
	}
	return rootReducer(state, action);
};

export const store = configureStore({
	reducer: combinedRootReducer,
	devTools: import.meta.env.DEV,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
